import React from 'react';
import PropTypes from 'prop-types';
import GameEventProp from '../../propTypes/gameEventProp';
import {
  displayUserName,
  GAME_EVENT_TYPE,
  TROPHY_CONFIG,
} from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';

function DefaultItem({ t, event }) {
  const message = (() => {
    switch (event.type) {
      case GAME_EVENT_TYPE.INFO:
        return event.info;
      case GAME_EVENT_TYPE.GAME_WIN:
        if (event.info) {
          return event.info;
        }
        if (event.user1) {
          return t(
            'challengeDetails_eventDescription_game_win',
            displayUserName(event.user1, true),
          );
        }
        return t('challengeDetails_eventDescription_game_win_noWinner');
      case GAME_EVENT_TYPE.TROPHY: {
        let trophyName = '';
        if (event.type === GAME_EVENT_TYPE.TROPHY && event.trophy) {
          const trophyConfig = TROPHY_CONFIG[event.trophy.type] || {};
          trophyName = t(trophyConfig.translationKey);
        }
        return t(
          'challengeDetails_eventDescription_trophy',
          event.user1.username,
          trophyName,
          event.trophy.value,
          event.trophy.unity,
        );
      }
      case GAME_EVENT_TYPE.GAME_START:
      case GAME_EVENT_TYPE.GOAL_80:
      case GAME_EVENT_TYPE.GOAL_90:
      case GAME_EVENT_TYPE.GOAL_100:
      default:
        if (event.info) {
          return event.info;
        }
        return t(`challengeDetails_eventDescription_${event.type}`);
    }
  })();

  const showUserInfo =
    event.user1 &&
    (event.type === GAME_EVENT_TYPE.INFO ||
      event.type === GAME_EVENT_TYPE.GAME_WIN ||
      event.type === GAME_EVENT_TYPE.TROPHY);

  return (
    <>
      {showUserInfo && (
        <div className="timeline-user-display">
          <img
            className="timeline-user-avatar"
            src={
              event.user1.image
                ? event.user1.image.thumb
                : '/images/no_user.png'
            }
            alt="user avatar"
          />
          {displayUserName(event.user1, true)}
        </div>
      )}
      <p style={showUserInfo ? { marginTop: '1rem' } : {}}>{message}</p>
    </>
  );
}

DefaultItem.propTypes = {
  t: PropTypes.func.isRequired,
  event: PropTypes.shape(GameEventProp.propType).isRequired,
};

export default translate(DefaultItem);
